// recording
export var READING_TRACKER_SESSION_START_V2 = "READING_TRACKER_SESSION_START_V2";
export var READING_TRACKER_SESSION_PROGRESS_V2 = "READING_TRACKER_SESSION_PROGRESS_V2";
export var READING_TRACKER_SESSION_RESULT_V2 = "READING_TRACKER_SESSION_RESULT_V2";
export var READING_TRACKER_SESSION_RESET = "READING_TRACKER_SESSION_RESET";
export var READING_TRACKER_SESSION_STORE_SOUND = "READING_TRACKER_SESSION_STORE_SOUND";

// playback
export var READING_TRACKER_PLAYBACK_INTERRUPT = "READING_TRACKER_PLAYBACK_INTERRUPT";
export var READING_TRACKER_PLAYBACK_START_V2 = "READING_TRACKER_PLAYBACK_START_V2";
export var READING_TRACKER_PLAYBACK_PROGRESS = "READING_TRACKER_PLAYBACK_PROGRESS";
export var READING_TRACKER_PLAYBACK_END = "READING_TRACKER_PLAYBACK_END";
export var READING_TRACKER_PLAYBACK_SEEK_TIME = "READING_TRACKER_PLAYBACK_SEEK_TIME";